/**
 * Job/Task Status ID constants
 * 
 * These represent the numeric status IDs used in the database
 * for job and task status tracking.
 */
export const JOB_STATUS_ID = {
  UPLOADING: 1,
  PROCESSING: 2,
  FAILED: 3,
  SUCCESS: 4,
} as const;

export type JobStatusId = typeof JOB_STATUS_ID[keyof typeof JOB_STATUS_ID];
